import { first, mergeMap, map, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { of ,  Observable } from 'rxjs';
import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators, AbstractControl } from "@angular/forms";
import { UserService, TenantService } from "../services";

@Component({
    selector: 'thin-signup-start',
    template: `
        <mat-card style="max-width: 300px;">
            <mat-card-content [formGroup]="form">
                <div *ngIf="!complete" fxLayout="column" fxLayoutAlign="start center">
                    <mat-form-field fxFlex="100">
                        <input matInput formControlName="firstName" placeholder="First Name">
                        <mat-error *ngIf="form.get('firstName').hasError('required')">First Name is required.</mat-error>
                    </mat-form-field>

                    <mat-form-field fxFlex>
                        <input matInput formControlName="lastName" placeholder="Last Name">
                        <mat-error *ngIf="form.get('lastName').hasError('required')">Last Name is required.</mat-error>
                    </mat-form-field>

                    <mat-form-field fxFlex>
                        <input matInput formControlName="emailAddress" placeholder="Email Address">
                        <mat-error *ngIf="form.get('emailAddress').hasError('validateUniqueEmail')">Email Address cannot be used.</mat-error>
                        <mat-error *ngIf="form.get('emailAddress').hasError('required')">Email Address is required.</mat-error>
                        <mat-error *ngIf="form.get('emailAddress').hasError('pattern')">Email address must be valid.</mat-error>
                    </mat-form-field>

                    <mat-form-field fxFlex>
                        <input matInput formControlName="company" placeholder="Company">
                    </mat-form-field>

                    <mat-form-field fxFlex>
                        <input matInput formControlName="title" placeholder="Title">
                    </mat-form-field>
                    
                </div>
                <div *ngIf="complete">
                    <h3>We just sent a signup email!</h3> 
                    <p>Please check your email to finish the signup process.</p>
                </div>
            </mat-card-content>

            <mat-card-actions fxLayout="row" fxLayoutAlign="space-around start">
                <button *ngIf="!complete" mat-raised-button color="primary" [disabled]="form.invalid" (click)="register()">Register</button>
            </mat-card-actions>
        </mat-card>
    `
})
export class ThinSignupStartComponent {
    form: FormGroup;
    tenant: any;
    complete: boolean;

    constructor(fb: FormBuilder, private tenantService: TenantService, private userService: UserService) {
        this.form = fb.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            emailAddress: ['', [Validators.required, Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,63}$')], this.validateUniqueEmail.bind(this)],
            company: [''],
            title: [''],
            isThin: [true]
        });
    }

    validateUniqueEmail(control: AbstractControl): Observable<{ [key: string]: any }> {
        return (this.tenant ? of(this.tenant) : this.tenantService.getUnauthTenantInfo()).pipe(
            mergeMap(tenant => {
                this.tenant = tenant;
                return this.userService.uaGetUserByEmail(control.value, this.tenant.hostname).pipe(debounceTime(250),distinctUntilChanged(),);
            }),  
            map(user => user ? { validateUniqueEmail: true } : undefined)
        );
    }

    register(): void {
        this.userService.startSignup(this.form.value, this.tenant.settings.signupConfirmationRedirect ? 'ws/ua/user/activate' : 'client/signup/confirmation').pipe(first()).subscribe(() => this.complete  = true); 
    }
}